import type { FC } from 'react';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Url } from '@wix/da-url';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import UnderlinedTabs from '@wix/da-ds/pkg/Tabs/dsPresets/UnderlinedTabs';
import { getStudioParams } from '../../../selectors/studio';

interface Props {
  className?: string;
}

const AppsTabs: FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const { unlisted } = useSelector(getStudioParams);
  return (
    <UnderlinedTabs
      className={className}
      uniformTabWidth={isMobile}
      items={[
        {
          label: t('studio.header.tabs.apps.subtabs.published'),
          index: 'published',
          href: Url.studio({ section: 'apps' }),
        },
        {
          label: t('studio.header.tabs.apps.subtabs.unpublished'),
          index: 'unpublished',
          href: Url.studio({ section: 'apps-unpublished' }),
        },
      ]}
      activeIndex={unlisted ? 'unpublished' : 'published'}
    />
  );
};

export default AppsTabs;
